import Cookies from 'js-cookie';

function AdminReportsController($scope, $http) {
  'ngInject';
  $scope.displayed = [];
  jQuery(document).ready(function ($) {
      if (Cookies.get('TLF_Auth_Token') !== undefined) {
          $http.get(TFL_Base_Url + 'admin/reports/transactions?ApiKey=' + Cookies.get('TLF_Auth_Token'))
            .then(function (response) {
                $scope.displayed = response.data;
            });
      }
  });
};

export default {
  name: 'AdminReportsCTRL',
  fn: AdminReportsController
}